<template>

  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-tabs position="top" id="customer-profile-tabs" class="w-full">
        <vs-tab label="General">
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onClickSundrySupplierProfileUpdate)" autocomplete="off">
              <vx-card class="mb-8" :title="`Supplier Status:  ${form.status.name}`" :titleColor="form.status.id === 3 ? 'primary' : 'warning'">
      
                <div class="vx-row mb-3 mt-8">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="company_name" name="company_name" rules="required" v-slot="{ errors }">
                      <small class="label">Company Name</small>
                      <vs-input  type="text" name="company_name" class="w-full" v-model="form.company_name" />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="website" name="website" rules="" v-slot="{ errors }">
                      <small class="label">Website</small>
                      <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="text" name="email" class="w-full" v-model="form.website" />
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="email" name="email" rules="email" v-slot="{ errors }">
                      <small class="label">Email</small>
                      <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="text" name="email" class="w-full" v-model="form.email" />
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                      <small class="label">Country</small>
                      <v-select :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="form.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                        <template v-slot:option="option">
                          <span>{{option.name}} </span>
                        </template>
                      </v-select>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <div class="vx-row">
                      <div class="vx-col w-1/3">
                        <ValidationProvider vid="telephone_country_code" name="telephone_country_code" rules="required" v-slot="{ errors }">
                          <small class="label">Country Code</small>
                          <v-select :filter-by="myFilter"  :clearable="false" name="telephone_country_code" placeholder="" label="isd_code" v-model="form.country_code_telephone" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                            <template v-slot:option="option">
                              <span>{{option.isd_code}} - {{option.name}} </span>
                            </template>
                          </v-select>
                          <span class="text-danger text-sm">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="vx-col w-2/3">
                        <ValidationProvider vid="site_telephone" name="site_telephone" rules="required|tel|max:15" v-slot="{ errors }">
                          <small class="label">Supplier Telephone</small>
                          <vs-input name="site_telephone"  class="w-full required" label="" v-model="form.telephone" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <div class="vx-row">
                      <div class="vx-col w-1/3">
                        <ValidationProvider vid="fax_country_code" name="fax_country_code" rules="" v-slot="{ errors }">
                          <small class="label">Country Code</small>
                          <v-select :filter-by="myFilter" :clearable="false" name="fax_country_code" placeholder="" label="isd_code" v-model="form.country_code_fax" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                            <template v-slot:option="option">
                              <span>{{option.isd_code}} - {{option.name}} </span>
                            </template>
                          </v-select>
                          <span class="text-danger text-sm">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="vx-col w-2/3">
                        <ValidationProvider vid="fax" name="fax" rules="" v-slot="{ errors }">
                          <small class="label">Supplier Fax</small>
                          <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="text" name="fax" class="w-full" v-model="form.fax" />
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/3 md:mb-0">
                    <ValidationProvider vid="is_vat_registration" name="is_vat_registration" rules="" v-slot="{ errors }">
                      <small class="label">Do you have a Company VAT Registration?</small>
                      <vs-switch v-model="form.is_vat_registration" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                        <span slot="on">Yes</span>
                        <span slot="off">No</span>
                      </vs-switch>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col w-1/3">
                    <ValidationProvider v-if="form.is_vat_registration" vid="is_vat_registration_country" name="is_vat_registration_country" rules="required" v-slot="{ errors }">
                      <small class="label">If Yes, In which country are you registered</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="is_vat_registration_country" placeholder="" label="name" v-model="form.is_vat_registration_country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/3 w-full md:mb-0">
                    <ValidationProvider v-if="form.is_vat_registration" vid="is_vat_registration_text" name="is_vat_registration_text" rules="required" v-slot="{ errors }">
                      <small class="label">If Yes, Company VAT Registration</small>
                      <vs-input type="text" name="is_vat_registration_text" class="w-full" v-model="form.is_vat_registration_text"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/3 md:mb-0">
                    <ValidationProvider vid="is_registration" name="is_registration" rules="" v-slot="{ errors }">
                      <small class="label">Do you have a Company Registration Number?</small>
                      <vs-switch v-model="form.is_registration" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                        <span slot="on">Yes</span>
                        <span slot="off">No</span>
                      </vs-switch>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col w-1/3">
                    <ValidationProvider v-if="form.is_registration" vid="is_registration_country" name="is_registration_country" rules="required" v-slot="{ errors }">
                      <small class="label">If Yes, In which country are you registered</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="is_registration_country" placeholder="" label="name" v-model="form.is_registration_country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/3 w-full md:mb-0">
                    <ValidationProvider v-if="form.is_registration" vid="is_registration_text" name="is_registration_text" rules="required" v-slot="{ errors }">
                      <small class="label">If Yes, Company Registration Number</small>
                      <vs-input type="text" name="is_registration_text" class="w-full" v-model="form.is_registration_text"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <vx-card  titleColor="#736F6E" title="Address" class="my-8" no-shadow>
                  <vs-row vs-w="12" class="mt-8">
                    <vs-col v-for="(address, index_address) in form.addresses" :key="index_address"
                            vs-type="flex"
                            vs-justify="center"
                            vs-align="center"
                            vs-lg="6" vs-sm="6" vs-xs="12"
                            class="px-4 pb-4">
                      <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteDeliveryAddresses(index_address)" :remove-card-action="form.addresses.length !== 1"  :collapse-action="false">
                        <div class="vx-row mb-2 w-full">
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider  :vid="index_address+'delivery_address_line1'" :name="index_address+'delivery_address_line1'" rules="required" v-slot="{ errors }">
                              <small class="label">Address Line 1</small>
                              <vs-input type="text" v-model="address.line1" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider  :vid="index_address+'delivery_address_line2'" :name="index_address+'delivery_address_line2'" rules="" v-slot="{ errors }">
                              <small class="label">Address Line 2</small>
                              <vs-input type="text" v-model="address.line2" name="line2" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                        </div>

                        <div class="vx-row mb-2 w-full">
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider  :vid="index_address+'delivery_address_line3'" :name="index_address+'delivery_address_line3'" rules="" v-slot="{ errors }">
                              <small class="label">Address Line 3</small>
                              <vs-input type="text" v-model="address.line3" name="line3" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider  :vid="index_address+'delivery_address_town_state'" :name="index_address+'delivery_address_town_state'" rules="required" v-slot="{ errors }">
                              <small class="label">Name of Town / State</small>
                              <vs-input type="text" v-model="address.town_state" name="town_state" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                        </div>

                        <div class="vx-row mb-2 w-full">
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider  :vid="index_address+'delivery_address_post_code'" :name="index_address+'delivery_address_post_code'" rules="required" v-slot="{ errors }">
                              <small class="label">Postal code</small>
                              <vs-input type="text" v-model="address.post_code" name="post_code" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider :vid="index_address+'delivery_address_country'" :name="index_address + 'delivery_address_country'" rules="required" v-slot="{ errors }">
                              <small class="label">Country</small>
                              <v-select :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="address.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                <template v-slot:option="option">
                                  <span>{{option.name}} </span>
                                </template>
                              </v-select>
                              <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                          </div>
                        </div>

                        <div class="vx-row mb-2 w-full">
                          <div class="vx-col md:w-full w-full md:mb-0">
                            <ValidationProvider  :vid="index_address+'delivery_address_note'" :name="index_address+'delivery_address_note'" rules="" v-slot="{ errors }">
                              <small class="label">Any Note</small>
                              <vs-input type="text" v-model="address.note" name="note" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                        </div>

                      </vx-card-custom>
                    </vs-col>
                  </vs-row>
                  <vs-button class="mt-4 mb-4 ml-4" @click="addDeliveryAddress" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add new address</vs-button>
                </vx-card>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                      <small class="label">Note</small>
                      <vs-textarea  class="mb-0" v-model="form.note" />
                    </ValidationProvider>
                  </div>
                </div>

                <div class="flex flex-wrap items-center justify-end mt-8">
                  <span style="display: none">{{form.status.id}}</span>
                  <vs-button button="submit" class="ml-4 mt-2"  v-can="'create-edit-other-suppliers'">Save Changes</vs-button>
                </div>

              </vx-card>
            </form>
          </ValidationObserver>
        </vs-tab>
        <vs-tab label="Sage" v-if="$canAny(['view-sage-supplier','create-edit-sage-supplier'])">
          <vx-card id="customer_profile" class="">
            <div v-if="form.sage_id" class="vx-row">
              Sage id: {{ sage_supplier_details.id }} <br>
              Sage ref: {{ sage_supplier_details.reference }} <br>
            </div>

            <!-- Medium -->
            <div class="flex items-center justify-center mb-4">
              <button
                v-if="form.sage_id"
                @click="onClickUnlickSageSupplierVerify()"
                class="cursor-pointer text-primary bg-transparent border-l border-t border-b border-primary hover:bg-primary hover:text-white active:bg-purple-600 font-bold uppercase text-sm px-6 py-3 rounded-l outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                type="button">
                Unlink existing supplier
              </button>
              <button
                v-if="!form.sage_id"
                @click="onClickCreateSageSupplier()"
                class="cursor-pointer text-primary bg-transparent border-l border-t border-b border-primary hover:bg-primary hover:text-white active:bg-purple-600 font-bold uppercase text-sm px-6 py-3 rounded-l outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                type="button">
                Create new sage supplier
              </button>
              <button
                v-if="!form.sage_id"
                @click="onClickLinkSageSupplier()"
                class="cursor-pointer text-primary bg-transparent border border-solid border-primary hover:bg-primary hover:text-white active:bg-purple-600 font-bold uppercase text-sm px-6 py-3 outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                type="button">
                Link to existing supplier
              </button>
              <button
                 id="supplier-sage-sync-button"
                 v-if="form.sage_id"
                 @click="onClickUpdateSageSupplier()"
                 class="cursor-pointer text-primary bg-transparent border border-solid border-primary hover:bg-primary hover:text-white active:bg-purple-600 font-bold uppercase text-sm px-6 py-3 outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                 type="button">
                 Synchronise data with sage
               </button>
            </div>
          </vx-card>
        </vs-tab>
      </vs-tabs>
    </div>
    <link-sage-supplier-pop-up ref="linkSageSupplierPopUp"/>
  </div>


</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'
  const SundrySupplierRepository = RepositoryFactory.get('sundry');
  const OtherSupplierRepository = RepositoryFactory.get('other_supplier');
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SageRepository = RepositoryFactory.get('sage')
  import LinkSageSupplierPopUp from "@/components/popups/supplier/sage/LinkSageSupplierPopUp";
  import SageHelper from '@/mixins/SageHelper'
  import { updateSageSupplier } from '@/services/SageService'

  function initialState() {
    return {
      countryCodes: [],
      form: {
        is_vat_registration: false,
        is_registration: false,
        status: {
          id: 1,
          name: ''
        }
      },
      supplierId : null,
      sage_supplier_details: {},
    }
  }
  export default {
    mixins: [SuccessMessage, ErrorMessages, SageHelper],
    data () {
      return initialState()
    },
    components: {
      'v-select': vSelect,
      LinkSageSupplierPopUp
    },
    computed: {
    },
    methods: {
      async loadData() {
        this.$vs.loading()
        this.supplierId = this.$route.params.id
        this.countryCodes =  (await SupplierManufactureRepository.getCountryCodes()).data.data
        const {data} = (await OtherSupplierRepository.getOtherSupplierProfile(this.supplierId)).data
        this.form = data
        this.$emit('fetchSupplierData', data)
        if (this.form.addresses.length === 0 ) {
          this.addDeliveryAddress()
        }
        this.form.is_vat_registration = this.form.is_vat_registration || false
        this.form.is_registration = this.form.is_registration || false

        this.$vs.loading.close()
      },

      addDeliveryAddress() {
        this.form.addresses.push({line1: '', line2: '', line3: '', town_state: '', post_code: '', country: '', type: 'main', note: ''})
      },
      deleteDeliveryAddresses(index) {
        this.form.addresses.splice(index, 1)
      },

      async onClickSundrySupplierProfileUpdate() {
          let payload = this.form

          this.$vs.loading();
          try {
            const change = await OtherSupplierRepository.updateOtherSupplierProfile(this.supplierId, payload);
            this.showSuccessMessage('Supplier Profile Update Successfully!')
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
      },
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
      async fetchSageSupplierDetails() {
        try {
          const { data } = (await SageRepository.getSageSupplierDetails(this.form.sage_id)).data
          this.sage_supplier_details = data
        } catch(e) {
          this.sageAuthHandler(e.response.status)
        }
      },
      async onClickCreateSageSupplier() {
        let payload = {
          name: this.form.company_name,
          reference: this.form.account_number ? this.form.account_number.match(/\d+/)[0] : this.form.id + "",
          account_status_type: 'AccountStatusActive',
          currency_id: await this.fetchSageCurrencyList(),
          telephone_country_code: this.form.country_code_telephone,
          telephone_subscriber_number: this.form.telephone,
          fax_country_code: this.form.country_code_fax,
          fax_subscriber_number: this.form.fax,
        }
        if(this.form.addresses.length > 0) {
          const main_address = this.form.addresses[0]
          const address = {
              address_1: main_address ? main_address.line1 : "",
              address_2: main_address ? main_address.line2 : "",
              address_3: main_address ? main_address.line3 : "",
              city: main_address ? main_address.town_state: "",
              country: main_address ? main_address.country : "",
              postcode: main_address ? main_address.post_code : ""
          }
          payload.main_address = address
        }
        
        try {
          await SageRepository.createSupplier(this.supplierId, payload)
          await this.loadData()
          this.showSuccessMessage('Sage supplier created successfully')
        } catch(e) {
          this.sageAuthHandler(e.response.status)
        }
      },
      async fetchSageCurrencyList() {
        try {
          const currency_list =  (await SageRepository.getCurrencies()).data.data
          const currencyMap = {
            'GBP': 'Pound Sterling',
            'USD': 'US Dollar',
            'EUR': 'Euro',
            'AUD': 'Australian Dollar',
            'DKK': 'Danish Krone'
          };
          const currencyName = currencyMap[this.form.account_currency];
          const sageCurrencyObj = currency_list.find(currency => currency.name === currencyName);
          return sageCurrencyObj ? sageCurrencyObj.id : null
        } catch (e) {
          this.sageAuthHandler(e.response.status)
        }
      },
      async onClickUnlickSageSupplierVerify() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Warning',
          acceptText: 'Proceed',
          text: 'You are about to unpair a nimble supplier with Sage. This means that future transactions in sage will not show in this account. Are you sure you wish to proceed?',
          accept: this.onClickUnlickSageSupplier,
          cancel: null
        })
      },
      async onClickUnlickSageSupplier() {
        try{
          await SageRepository.unLinkSageSupplier(this.supplierId, { sage_id: this.form.sage_id })
          this.showSuccessMessage('Sage supplier un-liked successfully')
          await this.loadData()
        } catch (e) {

        }
      },
      async onClickLinkSageSupplier() {
        await this.$refs.linkSageSupplierPopUp.openPopup(this.supplierId, this.form.company_name)
      },
      async onClickUpdateSageSupplier() {
        await this.$vs.loading({
          container: '#supplier-sage-sync-button',
          scale: 0.45
        })
        try {
          await updateSageSupplier(this.form)
          this.showSuccessMessage('Sage data synchronization successful!')
        } catch (e) {
          this.sageAuthHandler(e.response.status)
        }
        this.$vs.loading.close('#supplier-sage-sync-button > .con-vs-loading')
      },
    },
    async mounted() {
      await this.loadData()
      if(this.form.sage_id) {
        await this.fetchSageSupplierDetails()
      }
    }
  }
</script>

<style lang="scss">
#customer-profile-tabs {
  width: 100%;
  .vs-tabs--ul {
    display: flex;
  }
  .vs-tabs-position-bottom .vs-tabs--ul, .vs-tabs-position-top .vs-tabs--ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap !important;
    justify-content: space-evenly;
  }

  .vs-tabs--li {
    flex-grow: 1 !important;
  }

  .line-vs-tabs {
    display: none;
  }

  .vs-tabs--li.activeChild {
    border-width: 0 0 2px 0;
    border-color: transparent;
    border-style:solid;
  }
}
</style>
